import { ReactComponent as AccountManagerIcon } from 'assets/icons/24/account-manager.svg';
import { ReactComponent as AllAccountsIcon } from 'assets/icons/24/all-accounts.svg';
import { ReactComponent as OrdersTransactionsIcon } from 'assets/icons/24/orders-transactions.svg';
import { ReactComponent as TimeIcon } from 'assets/icons/24/time.svg';
import React, { useState } from 'react';

export interface ListItemLinkProps {
  id: string;
  Icon: any;
  primary: string;
  to: string;
}

interface DrawerState {
  mobileOpen: boolean;
  setMobileOpen: (open: boolean) => void;
  handleDrawerToggle: () => void;
  navItems: ListItemLinkProps[];
  footerItems: {label:string, to: string}[];
  getNavIcon: (id: string) => any
}

export enum DrawerNavigation {
  ACCOUNTS = 'ACCOUNTS',
  TRANSACTIONS = 'TRANSACTIONS',
  PENDING = 'PENDING',
  SETTINGS = 'SETTINGS'
}

export const DrawerContext = React.createContext<DrawerState>({} as DrawerState);

export const DrawerContextProvider = ({ children }: any) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const navItems: ListItemLinkProps[] = [
    {
      id: DrawerNavigation.ACCOUNTS,
      Icon: AllAccountsIcon,
      primary: 'Account',
      to: '/account',
    },
    {
      id: DrawerNavigation.TRANSACTIONS,
      Icon: OrdersTransactionsIcon,
      primary: 'Transactions',
      to: '/transactions',
    },
    {
      id: DrawerNavigation.PENDING,
      Icon: TimeIcon,
      primary: 'Pending',
      to: '/pending',
    },
    {
      id: DrawerNavigation.SETTINGS,
      Icon: AccountManagerIcon,
      primary: 'Settings',
      to: '/settings',
    },
  ];

  const footerItems = [
    {
      label: 'Guide',
      to: '/guide'
    },
    {
      label: 'Tx Status Guide',
      to: '/guide/tx-status-guide'
    }
  ];

  const getNavIcon = (id: string) => {
    const navItem = navItems.find((item) => item.id === id);
    if (navItem) {
      return navItem.Icon;
    }
    return () => (<></>);
  };


  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const [value] = useState({
    mobileOpen,
    setMobileOpen,
    handleDrawerToggle,
    navItems,
    getNavIcon,
    footerItems
  });

  return (
    <DrawerContext.Provider value={value}>
      {children}
    </DrawerContext.Provider>
  );
};

export const DrawerContextConsumer = DrawerContext.Consumer;
